// ==================================
// Layout Principal
// ==================================

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main content */}
      <div className="lg:pl-64">
        {/* Mobile header bar */}
        <div className="sticky top-0 z-30 lg:hidden flex items-center h-14 bg-white border-b border-stone-200 px-4">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 -ml-2 text-stone-500 hover:text-obsidian-900 hover:bg-stone-100 rounded-lg"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
          <div className="ml-3 flex items-center gap-2">
            <img src="/logo-sin-fondo-sinletras.png" alt="Alebrije Cloud" className="h-7 w-7 object-contain" />
            <span className="font-display font-bold text-obsidian-900">
              <span className="text-primary-600">Alebrije</span> Cloud
            </span>
          </div>
        </div>

        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default MainLayout;
